import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
} from "@angular/core";

@Directive({
  selector: "[appAutoWidht]",
})
export class AutoWidhtDirective implements AfterViewInit {
  private _texto: string;

  constructor(private el: ElementRef) {}

  @Input() set textoAutoWidhtDirective(val: string) {
    this._texto = val;

    if (!this.el.nativeElement.id) {
      return;
    }
    this.resize(this.el.nativeElement.id, this._texto);
  }

  @HostListener("input", ["$event"])
  onInput(ev: Event): void {
    ev.preventDefault();
    const input = <HTMLInputElement>ev.target;
    this.resize(input.id, input.value);
  }

  ngAfterViewInit() {
    if (!this.el || !this._texto) {
      return;
    }

    this.resize(this.el.nativeElement.id, this._texto);
  }

  public resize(id, texto) {
    const hideEl = document.getElementById("hide-resize-helper");
    hideEl.textContent = texto;

    const item = document.getElementById(id);
    if (id.indexOf("mne") !== -1) {
      hideEl.textContent = texto.toUpperCase();
    }

    const width = hideEl.offsetWidth + 45;
    this.el.nativeElement.style.width = width.toString() + "px";
  }
}
